import clsx from 'clsx'
import { Tooltip } from '@pepper/ui'

import s from './IntentPill.module.css'

type Props = {
  value: string
}

const intentMap: Record<
  string,
  { label: string; value: string; description: string }
> = {
  0: {
    label: 'C',
    value: 'commercial',
    description: 'Search for products, or services.',
  },
  1: {
    label: 'I',
    value: 'informational',
    description: 'Search for information on a topic.',
  },
  2: {
    label: 'N',
    value: 'navigational',
    description: 'Search for a specific page.',
  },
  3: {
    label: 'T',
    value: 'transactional',
    description: 'Search for a particular brand or product.',
  },
}

export const IntentPill = ({ value }: Props) => {
  return (
    <Tooltip
      key={intentMap[value].value}
      title={() => (
        <div>
          <span className={s.intentValue}>{intentMap[value].value}:&nbsp;</span>
          {intentMap[value].description}
        </div>
      )}
    >
      <div className={clsx(s.intent, s[intentMap[value].value])}>
        {intentMap[value].label}
      </div>
    </Tooltip>
  )
}
